import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import Context from './GrievanceFormContext';

import useServiceReducer from '../../../../shared/hooks/useServiceReducer';
import grievanceService from '../../../../services/grievanceService';
import grievanceReducer from '../../GrievanceReducer';
import SpinnerArea from '../../../../shared/components/SpinnerArea';

const GrievanceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const [hasAttempted, setHasAttempted] = useState(false);

  const [grievanceData, loading, error, , , reload] = useServiceReducer(
    () => grievanceService.getGrievanceFormContext(),
    grievanceReducer,
    ''
  );

  useEffect(() => {
    if (loading) {
      setHasAttempted(true);
    }

    if (hasAttempted && !loading && (error || !grievanceData)) {
      const timer = setTimeout(() => {
        navigate('/');
      }, 2000);

      return () => clearTimeout(timer);
    }

    return undefined;
  }, [loading, hasAttempted, error, grievanceData, navigate]);

  const value = useMemo(
    () =>
      grievanceData && {
        genders: grievanceData.genders || [],
        countries: grievanceData.countries || [],
        countriesClaimant: grievanceData.countriesClaimant || [],
        channels: grievanceData.channels || [],
        origins: grievanceData.origins || [],
        mainTopics: grievanceData.mainTopics || [],
        subTopics: grievanceData.subTopics || [],
        priorities: grievanceData.priorities || [],
        imminentRiskTypes: grievanceData.imminentRiskTypes || [],
        // internalPrioritizations: grievanceData.internalPrioritizations || [],
        currentPhases: grievanceData.currentPhases || [],
        reload,
        loading,
      },
    [grievanceData, reload, loading]
  );

  if (loading && !grievanceData) {
    return <SpinnerArea loading />;
  }

  return value && <Context.Provider value={value}>{children}</Context.Provider>;
};

export default GrievanceProvider;
